import { api } from './networkService';

class NotificationService {
    static async fetch(page, filters) {
        try {
            const response = await api.get(`api/user/notification`, {
                params: {
                    page: page,
                    perPage: 20,
                    ...filters
                }
            });
            return response.data;
        } catch (error) {
            console.error('Fetch notification error:', error);
            throw error;
        }
    }

    static async fetchOne(id) {
        try {
            const response = await api.get(`api/user/notification/${id}`);
            return response.data;
        } catch (error) {
            console.error('Fetch notification error:', error);
            throw error;
        }
    }

    static async add(notification) {
        try {
            const cleanedNotification = Object.fromEntries(
                Object.entries(notification).filter(([_, value]) => value && value !== '')
            );
            const response = await api.post(`api/user/notification`, cleanedNotification);
            return response;
        } catch (error) {
            console.error('Add notification error:', error);
            throw error;
        }
    }

    static async delete(id) {
        try {
            const response = await api.delete(`api/user/notification/${id}`);
            return response;
        } catch (error) {
            console.error('Delete notification error:', error);
            throw error;
        }
    }
}

export default NotificationService;
